const CustomLabel = ({ title, secondaryTitle, extraClassName, secondaryClassName }) => {
    return (
        <div>
            <h5 className={`mb-2 font-bold text-lg karla color-sycamore ${extraClassName || ""}`}>
                {title}
            </h5>
            {secondaryTitle && <h5 className={`mb-2 font-bold text-lg karla ${secondaryClassName || ""}`}>
                {secondaryTitle}
            </h5>}
        </div>
    )
}

export default CustomLabel